import ShiftReports from '@/app/shift-reports'
import { ability } from '@/casl/ability'
import { getFirstAccessibleRoute } from '@/constants/Auth'
import { createFileRoute, redirect } from '@tanstack/react-router'

const RouteComponent = () => {
  return <ShiftReports />
}

export const Route = createFileRoute('/_auth/_withProject/shift-reports')({
  beforeLoad: ({ context }) => {
    if (ability && context.auth.user && !ability.can('read', 'Vardiya Raporları')) {
      const permissions = context.auth.user.permissions || []
      const redirectPath = getFirstAccessibleRoute(permissions)
      throw redirect({
        to: redirectPath,
      })
    }
  },
  component: RouteComponent,
})
